import {
  useGetQuery,
  useLazyGetQuery,
  usePostMutation,
  usePutMutation,
  useDeleteMutation,
} from "slices/api";
import { UTILITY_ISSUE } from "tagTypes";

export const useUtilityIssueQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/utility-issue",
    query,
    tags: [UTILITY_ISSUE],
  });

export const useLazyUtilityIssueQuery = () => {
  const [getUtilityIssue, data] = useLazyGetQuery();
  const utilityIssue = async (query = {}) =>
    await getUtilityIssue(
      {
        endpoint: "/utility-issue",
        query,
        tags: [UTILITY_ISSUE],
      },
      true
    ).unwrap();
  return [utilityIssue, data];
};

export const useUtilityIssueByUtilityIdQuery = (id, query = {}) =>
  useGetQuery({
    endpoint: `/utility/${id}/utility-issue`,
    query,
    tags: [UTILITY_ISSUE],
  });

export const useLazyUtilityIssueByUtilityIdQuery = () => {
  const [getUtilityIssue, data] = useLazyGetQuery();
  const utilityIssue = async (id, query = {}) =>
    await getUtilityIssue(
      {
        endpoint: `/utility/${id}/utility-issue`,
        query,
        tags: [UTILITY_ISSUE],
      },
      true
    ).unwrap();
  return [utilityIssue, data];
};

export const usePostUtilityIssueMutation = () => {
  const [utilityIssue, data] = usePostMutation();
  const addUtilityIssue = async (payload, query = {}) =>
    await utilityIssue({
      endpoint: "/utility-issue",
      query,
      payload: payload || {},
      toastMessage: "Utility issue added successfully",
      tags: [UTILITY_ISSUE],
    }).unwrap();
  return [addUtilityIssue, data];
};

export const usePutUtilityIssueMutation = () => {
  const [utilityIssue, data] = usePutMutation();
  const updateUtilityIssue = async (payload, id, query = {}) =>
    await utilityIssue({
      endpoint: `/utility-issue/${id}`,
      query,
      payload: payload || {},
      toastMessage: "Utility issue updated successfully",
      tags: [UTILITY_ISSUE],
    }).unwrap();
  return [updateUtilityIssue, data];
};

export const useDeleteUtilityIssueMutation = () => {
  const [utilityIssue, data] = useDeleteMutation();
  const deleteUtilityIssue = async (id, query = {}) =>
    await utilityIssue({
      endpoint: `/utility-issue/${id}`,
      query,
      toastMessage: "Utility issue deleted successully",
      tags: [UTILITY_ISSUE],
    }).unwrap();
  return [deleteUtilityIssue, data];
};
